import { AcceptanceCriteriaWarmIschemicTimeType } from '@/api/apis/cases';
import { NameByValue } from '@/types';

export const WARM_ISCHEMIC_TIME_PREDEFINED_OPTIONS: NameByValue<AcceptanceCriteriaWarmIschemicTimeType, string>[] = [
  { value: AcceptanceCriteriaWarmIschemicTimeType.SystolicLessThan80, name: 'Systolic < 80' },
  { value: AcceptanceCriteriaWarmIschemicTimeType.SystolicLessThan50, name: 'Systolic < 50' },
  { value: AcceptanceCriteriaWarmIschemicTimeType.MapLessThan50, name: 'MAP < 50' },
  {
    value: AcceptanceCriteriaWarmIschemicTimeType.SystolicLessThan80SaturationLessThan80,
    name: 'Systolic < 80, Saturation < 80',
  },
];

export const EXTUBATION_TIME_PREDEFINED_OPTIONS = [30, 60, 90, 120];

export const WARM_ISCHEMIC_TIME_DEFAULT = 30;

export const FROM_EXTUBATION_TO_COLD_FLUSH_OPTIONS = [30, 45, 60];
export const SYSTOLIC_TIME_INITIATION_OPTIONS = [50, -1];
export const SATURATION_TIME_INITIATION_OPTIONS = [70, -1];
export const TOTAL_WARM_ISCHEMIC_TIME_OPTIONS = [30];
